import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../context/I18nContext';
import { publicApi } from '../api';
import { useApi } from '../hooks/useApi';
import { Calendar, ArrowRight, Newspaper } from 'lucide-react';
import { staticImg } from '../utils/media';

export default function BlogSection() {
  const { lang, tr } = useI18n();
  const { data: items } = useApi(() => publicApi.blog(lang), [lang]);

  const posts = items || [];
  if (posts.length === 0) return null;

  return (
    <section className="py-24 relative overflow-hidden bg-[#050508] border-t border-b border-white/5">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div>
            <span className="text-xs font-extrabold tracking-widest uppercase text-[#e4b44e]">BLOG & REHBERLER</span>
            <h2 className="font-display text-3xl md:text-4xl font-black text-white mt-2">
              En Son <span className="gold-text">Makaleler</span>
            </h2>
            <p className="text-white/60 text-sm mt-2 max-w-xl">
              Metin2 geliştirme, C++ & Python sistem entegrasyonu ve sunucu optimizasyonu ipuçları.
            </p>
          </div>
          <Link to="/blog" className="btn-gold h-10 px-6 rounded-lg inline-flex items-center gap-2 text-xs font-extrabold tracking-widest whitespace-nowrap self-start md:self-auto">
            <span>TÜM MAKALELERİ İNCELE</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {posts.slice(0, 3).map((b) => (
            <article key={b.id} className="rounded-2xl border border-white/8 bg-gradient-to-b from-[#111015] to-[#0a090c] overflow-hidden card-hover flex flex-col group">
              <Link to={`/blog/${b.slug}`} className="block aspect-video bg-[#0f0e12] overflow-hidden relative">
                {b.image ? (
                  <img src={staticImg(b.image)} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-[#1b1924] to-[#0a090c]">
                    <Newspaper className="w-10 h-10 text-white/20" />
                  </div>
                )}
                {b.category_name && (
                  <span className="absolute top-3 left-3 px-3 py-1 rounded-full text-[10px] font-extrabold uppercase tracking-wider bg-black/70 backdrop-blur border border-white/10 text-[#e4b44e]">
                    {b.category_name}
                  </span>
                )}
              </Link>
              <div className="p-6 flex-1 flex flex-col justify-between">
                <div>
                  {b.created_at && (
                    <div className="flex items-center gap-1.5 text-xs text-white/40 mb-3">
                      <Calendar className="w-3.5 h-3.5 text-[#e4b44e]" />
                      <span>{b.created_at.slice(0, 10)}</span>
                    </div>
                  )}
                  <h3 className="font-display text-base font-bold text-white group-hover:text-[#e4b44e] transition-colors line-clamp-2 leading-snug">
                    <Link to={`/blog/${b.slug}`}>{b.title}</Link>
                  </h3>
                  <p className="text-white/60 text-xs mt-2.5 line-clamp-3 leading-relaxed">{b.excerpt}</p>
                </div>
                <div className="mt-5 pt-4 border-t border-white/5 flex items-center justify-between">
                  <Link to={`/blog/${b.slug}`} className="text-xs font-extrabold text-[#e4b44e] inline-flex items-center gap-1.5 group-hover:translate-x-1 transition-transform">
                    <span>Devamını Oku</span>
                    <ArrowRight className="w-3.5 h-3.5" />
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
